import { mapKeys, camelCase } from 'lodash'
import ReportAttendanceSummary from '@/api/hr/report-attendance-summary'
import OrgChartStructure from '@/api/hr/org-chart-structure'
import EmployeeProfile from '@/api/hr/employee'
import { baseState, baseMutations, Pagination } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page || 1,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    return ReportAttendanceSummary.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchOrgStructures(context) {
    return OrgChartStructure.get({
      params: {
        page: -1,
        fields: {
          hris_org_chart_structure: 'org_chart_structure_id,org_chart_structure'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchEmployees(context, attributes = {}) {

    if (attributes.org_chart_structure_id === '' || attributes.org_chart_structure_id === null) return

    return EmployeeProfile.getByPositionHierarchies(attributes.org_chart_structure_id).then(response => {
      return Promise.resolve(response)
    })
  },

  exportExcel(context, { ...attributes }) {
    return ReportAttendanceSummary.exportExcel(attributes)
  },
}
